import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import {
  EventCalendar,
  EventReservedTickets,
} from 'app/pages/TicketSalePage/slice/types';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { dayColorsBasedOnStatus, getDayStatusOnCalendar } from 'utils/calendar';
import { useCalendarController } from './calendarContext';

interface CalendarWeekDayProps {
  day: DateTime;
  isToday: boolean;
  isTomorrow: boolean;
}

const CalendarWeekDay: React.FC<CalendarWeekDayProps> = ({
  day,
  isToday,
  isTomorrow,
}) => {
  const { t, i18n } = useTranslation();
  const { selectedDate, handleDateChange } = useCalendarController();
  const { calendar, reservedTickets } = useSelector(makeSelectedEvent);

  const status = getDayStatusOnCalendar(
    calendar as EventCalendar,
    reservedTickets as EventReservedTickets,
    day,
  );

  const isDisabled = status === 'sold-out' || status === 'unavailable';

  return (
    <button
      onClick={() => handleDateChange(day)}
      className={`p2-regular flex items-center justify-between gap-[4px] font-normal border text-left px-[12px] h-[46px] transition duration-200 rounded-md ${
        day.equals(selectedDate)
          ? 'border-neutral-1000 bg-neutral-40 shadow-md'
          : 'bg-neutral-10 border-neutral-40'
      } ${
        isDisabled ? 'cursor-not-allowed text-neutral-600' : 'cursor-pointer'
      }`}
      disabled={isDisabled}
    >
      <span className={`${isDisabled ? 'line-through' : ''}`}>
        {isToday
          ? t('ticketSale.today')
          : isTomorrow
          ? t('ticketSale.tomorrow')
          : day.setLocale(i18n.language).toFormat('cccc, LLLL d')}
      </span>
      {/* {status !== 'available' ? (
        <div
          className={`bg-${dayColorsBasedOnStatus[status]}-40 w-[32px] h-[32px] rounded-full flex justify-center items-center`}
        >
          <OveitIcon name="alertTriangle" />
        </div>
      ) : null} */}

      {status === 'available' ? null : (
        <span
          className={`${
            dayColorsBasedOnStatus[status]
          }-label shrink-0 truncate text-ellipsis whitespace-nowrap ${
            day.toFormat('cccc, LLLL d').length > 22 && status.length > 10
              ? 'max-w-[80px]'
              : ''
          }`}
        >
          {t(`ticketSale.calendarDayStatuses.${status}`)}
        </span>
      )}
    </button>
  );
};

export default CalendarWeekDay;
